module.exports = __webpack_public_path__ + "static/media/ic_permission.2b1abc55.svg";